class RequestDeduplicator {
  constructor() {
    this.ongoingRequests = new Map();
  }

  async deduplicate(key, requestFn) {
    if (this.ongoingRequests.has(key)) {
      return this.ongoingRequests.get(key);
    }

    const promise = requestFn().finally(() => {
      this.ongoingRequests.delete(key);
    });

    this.ongoingRequests.set(key, promise);
    return promise;
  }
}

const requestDeduplicator = new RequestDeduplicator();

export default requestDeduplicator;
